import classNames from 'classnames';
import { Checkbox } from '@material-ui/core';

import layoutStyles from '../../../layout.module.css';
import styles from '../../index.module.css';

import EmptyCheck from '../../../components/EmptyCheck';
import { makeMessage, postMessageToParent, cleanThePrice } from '../../utils';

const AssignmentCell = ({
    rootStyle,
    columnIndex,
    rows,
    suppliers,
    lots,
    rowIndex,
    isDisabled,
    isCheckboxDisabled,
    isLoading,
    takePrice,
    currency,
    localeCode,
    boundaryPrices
}) => {
    const row = rows[rowIndex - 1];
    const lot = lots[row.lotNum - 1];
    const invitedSupplier = suppliers[columnIndex - 1];
    const { suppliers: assignedSuppliers } = lot;
    const supplier = assignedSuppliers?.[invitedSupplier.id];
    const isChecked = !!supplier;
    const isPriceEditable = !isDisabled && isChecked;
    const boundaryPriceKey = `${row.variant}-${row.id}-supplier-${invitedSupplier.id}`;
    const boundaryPrice = boundaryPrices[boundaryPriceKey];

    const handleAssignOne = event => {
        if (isLoading || row.variant !== 'lot') {
            return;
        }
        const assignEvent = makeMessage('assignOne', {
            checked: event.target.checked,
            lotIndex: row.num - 1,
            supplierIndex: columnIndex - 1
        });
        postMessageToParent(assignEvent);
    };

    const handleUpdatePrice = event => {
        if (isLoading) {
            return;
        }
        const cleanedPrice = cleanThePrice(
            event.target.innerText,
            localeCode
        );
        event.target.innerText = cleanedPrice;
        const priceEvent = makeMessage('price', {
            value: cleanedPrice,
            lotIndex: row.lotNum - 1,
            lineItemId: row.variant === 'line_item' ? row.id : undefined,
            supplierIndex: columnIndex - 1,
            variant: row.variant
        });
        postMessageToParent(priceEvent);
    };

    const handlePriceLimitPaste = event => {
        event.preventDefault();
        if (isLoading) {
            return;
        }
        const pastedData = event.clipboardData.getData('text/html');
        const pasteEvent = makeMessage('priceLimitPaste', {
            payload: pastedData,
            rowIndex: rowIndex - 1,
            supplierIndex: columnIndex - 1
        });
        postMessageToParent(pasteEvent);
    };

    return (
        <div
            style={rootStyle}
            className={classNames(
                styles.checkWrap,
                layoutStyles.borderRight,
                layoutStyles.borderBottom
            )}
        >
            <div className={classNames('assignmentCheck')}>
                {row.variant === 'lot' && (
                    <Checkbox
                        icon={<EmptyCheck />}
                        checked={isChecked}
                        disabled={isCheckboxDisabled}
                        onClick={handleAssignOne}
                        data-supplier={supplier?.supplier_name}
                        data-lot={lot?.name}
                        data-purpose='assign-cell'
                    />
                )}
            </div>
            {takePrice && (
                <div
                    className={classNames(
                        layoutStyles.flex,
                        layoutStyles.contentCenter,
                        layoutStyles.itemsCenter,
                        layoutStyles.flex1,
                        layoutStyles.borderLeft,
                        {
                            editable: isPriceEditable
                        }
                    )}
                    data-supplier={supplier?.supplier_name}
                    data-variant={row.variant}
                    data-row={row.name}
                >
                    <span
                        style={{
                            wordBreak: 'keep-all'
                        }}
                        data-purpose='currency'
                    >
                        {currency}
                    </span>
                    <span
                        style={{
                            width: '80%',
                            textAlign: 'right'
                        }}
                        data-purpose='price'
                        contentEditable={isPriceEditable}
                        onBlur={handleUpdatePrice}
                        dangerouslySetInnerHTML={{
                            __html:
                                isChecked && boundaryPrice
                                    ? boundaryPrice.value
                                    : ''
                        }}
                        onPaste={handlePriceLimitPaste}
                    ></span>
                </div>
            )}
        </div>
    );
};

export default AssignmentCell;
